import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#6C7072",
      d: "M13.125 23c-.625 0-1.375-.25-1.875-.75C3.125 15.125 3 15 3 14.875l-.125-.125A8.24 8.24 0 0 1 .5 9v-.25c.125-4.5 3.75-8 8.25-8C10.125.75 12 1.5 13.125 3 14.25 1.5 16.25.75 17.625.75c4.5 0 8 3.5 8.25 8V9c0 2.25-.875 4.25-2.375 5.875l-.125.125c-.125.125-1.125 1-8.25 7.375-.625.375-1.25.625-2 .625m-8.25-8.5c.5.5 3 2.25 7.625 6.25.375.375.875.375 1.25 0 4.75-4.25 7.5-6.625 8.125-7.125L22 13.5A6.34 6.34 0 0 0 23.875 9v-.25C23.75 5.25 21 2.625 17.5 2.625c-.875 0-2.625.625-3.25 2-.25.5-.75.75-1.25.75s-1-.25-1.25-.75c-.625-1.25-2.25-2-3.25-2-3.375 0-6.25 2.75-6.375 6.125v.375c0 1.625.75 3.25 1.875 4.375z"
    }, null, -1)
  ]))]))
}
export default { render: render }